import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useIntegrationQueueStatusReducer = () =>
	useSelector((state: ApplicationState) => state.integrationQueueStatus);
